import {Command} from './Command';
import {ChangeWallSizeAction} from '../actions';
import {WallBuilderService} from '../../wall/wall-builder.service';

export class ChangeWallSizeCommand extends Command<ChangeWallSizeAction> {

  private config: {};

  constructor(
    private wallBuilder: WallBuilderService
  ) {
    super();
  }

  do(action: ChangeWallSizeAction) {
    this.config = action.config;
  }

  undo() {
    this.wallBuilder.createWall(this.config);
  }

  dispose() {
    this.config = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/ChangeWallSizeCommand.ts